import React, { useEffect } from "react";
import { Link } from "@/components/common/Link";
export default function Header() {
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header id="header" className="dark sticky top-0 z-50 w-full bg-[#04052F]">
      <div className="container mx-auto px-8 md:px-12 py-6 md:py-8 flex items-center justify-between">
        <div className="flex-shrink-0">
          <Link to="/HomePage" className="block group">
            <span className="text-3xl md:text-4xl font-extrabold text-white font-sans tracking-tight transition-opacity duration-300 group-hover:opacity-90">
              Alliloop
            </span>
          </Link>
        </div>

        {}
      </div>
    </header>;
}